<template>
  <div class="location">
    <location-icon class="location__icon" />
    <div class="location__details">
      {{ name }}
      <span class="location__address"> {{ address }}, {{ town }} </span>
    </div>
  </div>
</template>

<script>
import LocationIcon from "@/assets/images/location-icon.svg";

export default {
  name: "BaseLocation",
  components: {
    LocationIcon
  },
  props: {
    name: {
      type: String,
      required: true
    },
    address: {
      type: String,
      required: true
    },
    town: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.location {
  display: flex;

  &__icon {
    align-self: center;
    margin-right: 20px;
  }

  &__address {
    display: block;
    color: $color-grey-400;
  }
}
</style>
